import dayjs from 'dayjs';

import { DB_DATE_FORMAT } from 'core/constants';

import { QuotesDashboardDateRange } from './enums';

export const getQuotesDashboardDateRange = (type: QuotesDashboardDateRange): string => {
  const now = dayjs();
  const format = DB_DATE_FORMAT;

  switch (type) {
    case QuotesDashboardDateRange.MONTH_TO_DATE: {
      const startOfMonth = now.startOf('month').format(format);
      const today = now.format(format);

      return `${startOfMonth}|${today}`;
    }
    case QuotesDashboardDateRange.YEAR_TO_DATE: {
      const startOfYear = now.startOf('year').format(format);
      const today = now.format(format);

      return `${startOfYear}|${today}`;
    }
    case QuotesDashboardDateRange.PREVIOUS_MONTH: {
      const previousMonth = now.subtract(1, 'month');
      const startOfPreviousMonth = previousMonth.startOf('month').format(format);
      const endOfPreviousMonth = previousMonth.endOf('month').format(format);

      return `${startOfPreviousMonth}|${endOfPreviousMonth}`;
    }
    case QuotesDashboardDateRange.PREVIOUS_YEAR: {
      const previousYear = now.subtract(1, 'year');
      const startOfPreviousYear = previousYear.startOf('year').format(format);
      const endOfPreviousYear = previousYear.endOf('year').format(format);

      return `${startOfPreviousYear}|${endOfPreviousYear}`;
    }
    default:
      return '';
  }
};
